export const successMessages = {
    erpTransfer: "Erp aktarımı başarılı. Mesaj: ",
    statusActive:"Durum aktife alındı",
    statusPassive: "Durum pasife alındı.",
    connectionRemoved: "Kullanıcının müşteri ile olan bağlantısı kaldırıldı.",
    listSaved: "Liste başarılı bir şekilde kaydedildi.",
    add: "Yeni kayıt başarılı bir şekilde oluşturuldu.",
    update: "Kayıt başarılı bir şekilde güncellendi.",
    userMatched: "Kullanıcı başarılı bir şekilde eşleştirildi."

}